export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://public.readdy.ai/ai/img_res/cf43b33b431fca2496da47fe88fefdb6.jpg" 
          alt="Professional Home Cleaning Services"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight">
          Professional Home<br />Cleaning Services
        </h1>
        <p className="text-base sm:text-xl md:text-2xl text-white/95 mb-7 sm:mb-10 max-w-3xl mx-auto leading-relaxed px-2">
          Experience the difference of a spotless home with our trusted cleaning experts. Quality service, affordable rates, and 100% satisfaction guaranteed.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center px-4 sm:px-0">
          <button 
            onClick={() => scrollToSection('contact')}
            className="w-full sm:w-auto bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            Request a Free Quote
          </button>
          <button 
            onClick={() => scrollToSection('services')}
            className="w-full sm:w-auto bg-white text-gray-800 px-8 py-4 rounded-lg text-base font-semibold hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            View Our Services
          </button>
          <a
            href="https://wa.me/18603785186"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto flex items-center justify-center gap-3 bg-green-500 text-white px-8 py-3 rounded-lg hover:bg-green-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            <div className="flex flex-col items-start">
              <span className="text-base font-bold leading-tight">Karolay Cleaning</span>
              <span className="text-xs text-white/80 leading-tight">+1 (860) 378-5186</span>
            </div>
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button onClick={() => scrollToSection('about')} className="text-white/80 hover:text-white transition-colors">
          <i className="ri-arrow-down-line text-3xl"></i>
        </button>
      </div>
    </section>
  );
}